import type { VolunteerActivityType } from '@/queries/constants'
import type { UserContextType } from '@/client/context/user'

import { validateUserCanSubmitNonTeamVolunteerActivity } from './validateVolunteerActivitySubmission'

export default function canUserSubmitNonTeamVolunteerActivity(
  user: UserContextType,
  type: VolunteerActivityType
): boolean {
  try {
    validateUserCanSubmitNonTeamVolunteerActivity(user, type)
    return true
  } catch {
    return false
  }
}
